<template>
	<div>
		<button
			class="nav-sidebar-toggle-btn"
			@click="toggleSidebar"
			:title="sidebarCollapsed ? $t('nav_show_menu') : $t('nav_hide_menu')"
		>
			<em
				class="icon ni"
				:class="sidebarCollapsed ? 'ni-menu' : 'ni-chevron-left'"
			></em>
		</button>
		<div
			class="nk-aside"
			data-content="sideNav"
			data-toggle-overlay="true"
			data-toggle-screen="lg"
			data-toggle-body="true"
		>
			<div class="nk-sidebar-menu" data-simplebar>
				<!-- Menu -->
				<ul class="nk-menu">
					<li class="nk-menu-heading">
						<h6 class="overline-title">{{ $t('nav_menu') }}</h6>
					</li>
					<li class="nk-menu-item">
						<router-link
							:to="{ name: 'dashboard', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon"
								><em class="icon ni ni-dashboard"></em
							></span>
							<span class="nk-menu-text">{{ $t('nav_projects') }}</span>
						</router-link>
					</li>
					<li class="nk-menu-item">
						<router-link
							:to="{ name: 'web-app', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<span class="material-icons md-48">web</span>
							</span>
							<span class="nk-menu-text">{{ $t('nav_app') }}</span>
						</router-link>
					</li>
					<li class="nk-menu-item">
						<router-link
							:to="{ name: 'imagelib', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<em class="icon ni ni-img"></em>
							</span>
							<span class="nk-menu-text">{{ $t('nav_image_gallery') }}</span>
						</router-link>
					</li>
					<li class="nk-menu-item">
						<router-link
							:to="{ name: 'reportsettings', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<em class="icon ni ni-setting"></em>
							</span>
							<span class="nk-menu-text">{{ $t('nav_report_settings') }}</span>
						</router-link>
					</li>

					<li class="nk-menu-item" v-if="account_role_permissions">
						<router-link
							:to="{ name: 'permissions', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<em class="icon ni ni-lock-alt"></em>
							</span>
							<span class="nk-menu-text">{{ $t('nav_permissions') }}</span>
						</router-link>
					</li>

					<li class="nk-menu-item" v-if="bookings_role_permissions">
						<router-link
							:to="{ name: 'bookinghistory', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<em class="icon ni ni-calendar"></em>
							</span>
							<span class="nk-menu-text">{{ $t('nav_booking_history') }}</span>
						</router-link>
					</li>

					<li class="nk-menu-item" v-if="users_role_permissions">
						<router-link
							:to="{ name: 'userlist', params: {} }"
							tag="a"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<em class="icon ni ni-users"></em>
							</span>
							<span class="nk-menu-text">{{ $t('nav_user_list') }}</span>
						</router-link>
					</li>

					<li class="nk-menu-item">
						<a
							href="https://wiki.inspect-app.de/s/9373bb06-c688-4a79-88aa-fcc477d5d9ad"
							target="_blank"
							class="nk-menu-link"
						>
							<span class="nk-menu-icon">
								<span class="material-icons md-48">support</span>
							</span>
							<span class="nk-menu-text">{{ $t('nav_help_center') }}</span>
						</a>
					</li>

					<li class="nk-menu-item" v-if="canAddProject">
						<a href="#" class="nk-menu-link"
							><span class="nk-menu-icon"
								><em class="icon ni ni-user-list"></em></span
							><span class="nk-menu-text">{{ $t('nav_master_data') }}</span></a
						>
						<ul class="nk-menu-sub">
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'contacts', params: {} }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('nav_contacts') }}</span>
								</router-link>
							</li>
							<!--
                            <li class="nk-menu-item">
                                <router-link :to="{ name: 'contacts', params: {} }" tag="a" class="nk-menu-link">
                                    <span class="nk-menu-text">User</span>
                                </router-link>
                            </li>  
                            -->
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'sites', params: {} }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('nav_sites') }}</span>
								</router-link>
							</li>
						</ul>
					</li>
					<li class="nk-menu-item" v-if="hasDmAccess">
						<a href="#" class="nk-menu-link"
							><span class="nk-menu-icon"><em class="icon ni ni-db"></em></span
							><span class="nk-menu-text">{{
								$t('dm_nav_datenstamm')
							}}</span></a
						>
						<ul class="nk-menu-sub">
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-dashboard' }"
									tag="a"
									exact
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_dashboard') }}</span>
								</router-link>
							</li>
							<li
								class="nk-menu-item"
								:class="{
									active:
										$route.name === 'dm-anlagen' ||
										$route.name === 'dm-anlage-detail',
								}"
							>
								<router-link
									:to="{ name: 'dm-anlagen' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_anlagen') }}</span>
								</router-link>
							</li>
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-parks' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_parks') }}</span>
								</router-link>
							</li>
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-adressen' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_adressen') }}</span>
								</router-link>
							</li>
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-dokumente' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_dokumente') }}</span>
								</router-link>
							</li>
							<!-- MaStr vorerst ausgeblendet
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-mastr' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_mastr') }}</span>
								</router-link>
							</li>
							-->
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-preislisten' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{
										$t('dm_nav_preislisten')
									}}</span>
								</router-link>
							</li>
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-kalkulator' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{
										$t('dm_nav_kalkulator')
									}}</span>
								</router-link>
							</li>
							<li class="nk-menu-item" v-if="hasDmAccess">
								<router-link
									:to="{ name: 'dm-preisliste-chat' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_ai_chat') }}</span>
								</router-link>
							</li>
							<li class="nk-menu-item">
								<router-link
									:to="{ name: 'dm-audit' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_auditlog') }}</span>
								</router-link>
							</li>
							<li class="nk-menu-item" v-if="hasDmAccess">
								<router-link
									:to="{ name: 'dm-ai-usage' }"
									tag="a"
									class="nk-menu-link"
								>
									<span class="nk-menu-text">{{ $t('dm_nav_ai_usage') }}</span>
								</router-link>
							</li>
						</ul>
					</li>
				</ul>
			</div>
			<!-- .nk-sidebar-menu -->
			<div class="nk-aside-close">
				<a href="#" class="toggle" data-target="sideNav"
					><em class="icon ni ni-cross"></em
				></a>
			</div>
			<!-- .nk-aside-close -->
		</div>
		<!-- .nk-aside -->
	</div>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
	name: 'Home',
	components: {},
	data() {
		return {
			sidebarCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
		};
	},
	computed: {
		account_role_permissions: function() {
			return this.$store.state.account_role.permissions == 'write';
		},
		bookings_role_permissions: function() {
			return this.$store.state.account_role.bookings == 'write';
		},
		users_role_permissions: function() {
			return this.$store.state.account_role.users == 'write';
		},
		canAddProject: function() {
			return this.$store.state.login_system == 'inspect';
		},
		hasDmAccess: function() {
			return this.$store.getters.hasDmAccess;
		},
	},
	created() {
		EventBus.$off('toggle:mobile:menu');
		EventBus.$on('toggle:mobile:menu', this.toggleMobileMenu);
	},
	watch: {
		sidebarCollapsed: function(val) {
			if (val) {
				document.body.classList.add('sidebar-collapsed');
			} else {
				document.body.classList.remove('sidebar-collapsed');
			}
		},
	},
	mounted() {
		if (this.sidebarCollapsed) {
			document.body.classList.add('sidebar-collapsed');
		}
	},
	methods: {
		toggleSidebar: function() {
			this.sidebarCollapsed = !this.sidebarCollapsed;
			localStorage.setItem('sidebarCollapsed', this.sidebarCollapsed);
		},
		toggleMobileMenu: function() {
			$('.nk-aside').addClass('mobile-menu');
			if ($('.nk-aside').hasClass('content-active')) {
				$('.nk-aside').removeClass('content-active');
			} else {
				$('.nk-aside').addClass('content-active');
			}
		},
	},
};
</script>

<style>
.nav-sidebar-toggle-btn {
	position: fixed;
	top: 84px;
	left: 234px;
	z-index: 701;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	border: 1px solid #e2e8f0;
	background: #fff;
	display: none;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	padding: 0;
	color: #64748b;
	transition: left 0.25s ease, color 0.15s, border-color 0.15s;
}

.nav-sidebar-toggle-btn:hover {
	color: #e8751a;
	border-color: #e8751a;
}

@media (min-width: 992px) {
	.nav-sidebar-toggle-btn {
		display: flex;
	}

	body.sidebar-collapsed .nav-sidebar-toggle-btn {
		left: 16px;
	}

	body.sidebar-collapsed .nk-aside {
		width: 0 !important;
		margin-right: 0 !important;
		overflow: hidden !important;
		padding: 0 !important;
		border: none !important;
	}

	body.sidebar-collapsed .nk-aside .nk-sidebar-menu,
	body.sidebar-collapsed .nk-aside .nk-aside-close {
		display: none;
	}

	body.sidebar-collapsed .has-aside .nk-content-body {
		width: 100% !important;
	}

	.nk-aside {
		position: sticky !important;
		top: 75px;
		align-self: flex-start;
		max-height: calc(100vh - 75px);
		overflow-y: auto;
	}
}
</style>
